import type { ScreenerExchangeData } from '@/types'
import { formatUtc } from './chartUtils'

export function formatFundingRate(rate: number | null | undefined): string {
  if (rate == null || !Number.isFinite(rate)) return 'N/A'
  const percentage = rate * 100
  const magnitude = Math.abs(percentage)
  const digits = magnitude > 0 && magnitude < 0.0001 ? 6 : 4
  return `${rate > 0 ? '+' : ''}${percentage.toFixed(digits)}%`
}

export function fundingSnapshotDescription(data?: Partial<ScreenerExchangeData>): string {
  if (data?.funding_rate == null || !Number.isFinite(data.funding_rate)) {
    return 'Current funding rate unavailable for this exchange.'
  }
  const rows = [`Latest collected funding rate: ${formatFundingRate(data.funding_rate)}`]
  if (data.funding_time != null && Number.isFinite(data.funding_time) && data.funding_time > 0) {
    rows.push(`Next funding: ${formatUtc(data.funding_time * 1000)}`)
  }
  if (data.funding_updated_at != null && Number.isFinite(data.funding_updated_at) && data.funding_updated_at > 0) {
    rows.push(`Ticker snapshot: ${formatUtc(data.funding_updated_at * 1000)}`)
  }
  rows.push('Current snapshot; independent of the OI crosshair time.')
  return rows.join('\n')
}
